/*
A plain checkbox, replacing @material-ui/core/Checkbox.

Native inputs are already how the rest of this codebase does checkboxes - 53 files use
`<input type="checkbox">` directly - so the ten MUI ones were the odd pattern out, not the
norm. This keeps them looking like one another rather than like fifty-three separate
opinions, and it is the last thing standing between several screens and dropping MUI.

The prop surface deliberately mirrors MUI's so the call sites only had to change their
import: `checked`, `onChange`, `disabled`, `name`, `value`, `id`, `inputProps`. That
includes MUI's two-argument onChange(event, checked) - native inputs only pass the event,
and a caller reading the second argument would silently get undefined instead of a
boolean.

`color` is accepted and ignored. MUI used it to pick between its theme palettes; there is
one checkbox style here, set in styles/_checkbox.scss.
*/
import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({
  checked, onChange, disabled, name, value, id, className, inputProps, color,
}) => (
  <input
    type="checkbox"
    className={['ps-checkbox', className].filter(Boolean).join(' ')}
    checked={!!checked}
    disabled={disabled}
    name={name}
    value={value}
    id={id}
    onChange={onChange ? event => onChange(event, event.target.checked) : undefined}
    data-color={color || undefined}
    {...inputProps}
  />
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  // (event, checked) => void, matching the MUI signature this replaced.
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  id: PropTypes.string,
  className: PropTypes.string,
  // Escape hatch for aria-* and the like, spread onto the input.
  inputProps: PropTypes.shape({}),
  // Accepted for call-site compatibility; not used.
  color: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: false,
  onChange: undefined,
  disabled: false,
  name: undefined,
  value: undefined,
  id: undefined,
  className: '',
  inputProps: undefined,
  color: undefined,
};

export default Checkbox;
